import { __assign, __extends } from "tslib";
// DS: I20
// from GDrive
import React from 'react';
import IconWrap from '../IconWrap';
var Search = /** @class */ (function (_super) {
    __extends(Search, _super);
    function Search() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Search.prototype.render = function () {
        return (React.createElement(IconWrap, __assign({}, this.props),
            React.createElement("svg", { width: "0", height: "0", viewBox: "-3 -3 23 22", version: "1.1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" },
                React.createElement("g", null,
                    React.createElement("path", { d: "M13.1764706,6.58823529 C13.1764706,10.226698 10.226698,13.1764706 6.58823529,13.1764706 C2.94977255,13.1764706 0,10.226698 0,6.58823529 C0,2.94977255 2.94977255,0 6.58823529,0 C10.226698,0 13.1764706,2.94977255 13.1764706,6.58823529 Z M11.2,6.58823529 C11.2,4.04131137 9.13515922,1.97647059 6.58823529,1.97647059 C4.04131137,1.97647059 1.97647059,4.04131137 1.97647059,6.58823529 C1.97647059,9.13515922 4.04131137,11.2 6.58823529,11.2 C9.13515922,11.2 11.2,9.13515922 11.2,6.58823529 Z", id: "Combined-Shape" }),
                    React.createElement("rect", { id: "Rectangle-12", transform: "rotate(45 12.9 12.511)", x: "10.077", y: "11.57", width: "5.647", height: "1.882" })))));
    };
    return Search;
}(React.Component));
export { Search };
export default Search;
//# sourceMappingURL=Search.js.map